<template>
  <div>
    <div v-if="!gameReady" class="loading" >
      <img src="@/assets/images/loading.png" alt="loading" />
      <span>资源加载中...</span>
    </div>
    <!-- 游戏容器 -->
    <div ref="gameContainer" class="game-container"></div>
    <!-- UI层 -->
    <div ref="uiContainer" class="ui-container">
      <GameKeyboard ref="refKeyboard" />
    </div>
    <ScreenAdapter />
  </div>
</template>

<script>
import { mapActions } from "vuex";
const GameKeyboard = () => import("./components/GameKeyboard.vue");
import GameManager from "./gameManager";
import Vue from "vue";
export const EventBus = new Vue();
import { initRem } from "./gameRem";
import ScreenAdapter from "../level/finger/ScreenAdapter.vue";
import mobileMixin from "@/utils/mobileMixin";
import { isStudentEnd } from "@/utils";
import { getKeyboardDetail } from "@http/index";

export default {
  mixins: [mobileMixin],
  components: {
    GameKeyboard,
    ScreenAdapter,
  },
  data() {
    return {
      input: "",
      nextKey: "",
      gameInfo: {
        sigleRight: false,
        in: "",
      },
      gameReady: false,
      node_name: "",
      node_id: "",
    };
  },
  mounted() {
    initRem();
    if (!this.$route.query.restart) {
      this.getInitData();
    }
    const isRestart = this.$route.query.restart;
    console.log("isRestart", isRestart);
    const isMuted = this.$store.state.keyboardGame.isMuted;
    console.log("isMuted init:", isMuted);
    this.game = new GameManager({
      w: 1280,
      h: 720,
      parent: this.$refs.gameContainer,
      eventBus: EventBus,
      skipLoading: isRestart ? true : false,
      isMuted: isMuted,
    });

    this.game.events.on("game-over", this.handleOver, this);
    this.game.events.on("ready", () => {
      const gameSce = this.game.scene.getScene("GameScene");
      gameSce.events.on("game-start", this.handleStart, this);
      gameSce.events.on("game-over", this.handleOver, this);
    });
    
    // 监听资源加载完成
    this.game.events.on("loadComplete", () => {
      console.log("资源加载完成");
      this.gameReady = true; // 隐藏loading界面
    });
    EventBus.$on("gameReady", this.onGameReady);
    EventBus.$on("gameFail", this.onGameFail);
    EventBus.$on("setPause", this.handlePause);
    EventBus.$on("mute", this.handleMute);
  },

  beforeDestroy() {
    this.game.destroy(true);
    this.game = null;
    this.resizeObserver.disconnect();
    if (this.metaElement) {
      document.head.removeChild(this.metaElement);
    }
  },

  methods: {
    ...mapActions("keyboardGame", [
      "pauseGame",
      "resumeGame",
      "startGame",
      "mute",
      "gameOver"
    ]),
    showPageLog(clickname) {
      if (!this.$route.query.keyboard_id) {
        return;
      }
      const data = {
        clickname,
        keyboard_id: this.$route.query.keyboard_id,
        practical_type: 3, // 1=字符输入型 2=段落输入型 3=游戏练习
        plan_id: this.$route.query.planId || "",
        course_id: this.$route.query.courseId || "",
        outline_id: this.$route.query.outlineId || "",
        isapp: isStudentEnd() ? "0" : "1",
        sectionName: this.node_name,
        sectionId: this.node_id,
      };
      window.logger.sendLog("click", data);
    },
    getInitData() {
      getKeyboardDetail({
        keyboard_id: this.$route.query.keyboard_id,
        node_id: this.$route.query.node_id,
      }).then(res => {
        const { node_name, node_id } = res.data
        this.node_name = node_name;
        this.node_id = node_id;
        this.showPageLog("jiuge_game_section_show");
      })
    },
    handlePause(isPaused) {
      if (isPaused) {
        this.pauseGame();
      } else {
        this.resumeGame();
      }
    },
    handleMute(isMuted) {
      this.mute(isMuted);
      this.game.scene.getScene("GameScene").handleMute(isMuted);
    },
    onGameReady() {
      console.log("游戏已经转笔哈！");
      this.showPageLog("jiuge_practica_section_show");
      this.startGame();
    },
    // 游戏结束 测试
    onGameFail() {
      console.log("游戏已经结束啦！！！");
      this.gameOver(false);
    },
    updatePhaser(data) {
      const gameS = this.game.scene.getScene("GameScene");
      if (gameS && gameS.processData) {
        gameS.processData(this.gameInfo);
      }
    },
    handleStart() {
      console.log("start处理");
    },
    handleOver() {
      console.log("index.vue handleOver 游戏结束啦！！！");
    },
  },
  watch: {
    "gameInfo.sigleRight": function (newVal) {
      this.updatePhaser(newVal);
    },
    input: function (newVal) {
      this.gameInfo.in = newVal;
      this.updatePhaser(newVal);
    },
    deep: true,
  },
};
</script>

<style scoped lang="less">
.loading {
  width: 100vw;
  // height: 100vh;
  height: 100%;
  overflow: hidden;
  position: fixed; /* 改为固定定位 */
  top: 0;
  left: 0;
  background: #e6f1fe;
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 34px;
  color: gray;
  img {
    margin-bottom: 20px;
    width: 200px;
  }
}
.game-container {
  width: 100vw;
  // height: 100vh;
  height: 100%;
  overflow: hidden;
  position: fixed; /* 改为固定定位 */
  top: 0;
  left: 0;
  background: #e6f1fe;
  z-index: 0; /* 建立层叠上下文 */
}

.ui-container {
  /* 固定设计尺寸 */
  width: 100%; /* 根据设计稿宽度 */
  height: 720px; /* 固定设计高度 */
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  overflow: hidden;
}
</style>
